// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home { max-width: 100%; }

/* ── HERO ── */
.home-hero {
  position: relative;
  background: var(--ink, #15140F);
  border: 1px solid var(--line-dark, #3A3728);
  border-radius: var(--radius, 12px);
  padding: 44px 36px;
  margin-bottom: 28px;
  overflow: hidden;
}
.home-hero-grid {
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(240,236,224,.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(240,236,224,.05) 1px, transparent 1px);
  background-size: 38px 38px;
  mask-image: radial-gradient(ellipse 80% 90% at 0% 0%, #000 30%, transparent 100%);
}
.home-hero-content { position: relative; z-index: 1; max-width: 640px; }
.home-hero-title {
  font-family: 'Oswald', sans-serif;
  text-transform: uppercase;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: .02em;
  color: #F0ECE0;
  margin-bottom: 10px;
}
.home-hero-sub {
  color: #A9A794;
  font-size: 14.5px;
  margin-bottom: 18px;
  max-width: 480px;
}
.home-hero-link {
  display: inline-block;
  color: #8FADF7;
  font-size: 13.5px;
  font-weight: 600;
  text-decoration: none;
}
.home-hero-link:hover { color: #F0ECE0; }

.home-hero-stats {
  position: relative; z-index: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(240,236,224,.1);
}
.home-stat { display: flex; flex-direction: column; gap: 4px; }
.home-stat span {
  font-size: 11px; color: #8F8B78; text-transform: uppercase; letter-spacing: .04em;
}
.home-stat b {
  font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 600; color: #F0ECE0;
}
.home-stat b.amber { color: #E0A354; }

/* ── NAV GRID ── */
.home-nav-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}
.home-nav-card {
  display: flex; align-items: flex-start; gap: 14px;
  background: #fff;
  border: 1px solid var(--line, #DEDACB);
  border-radius: var(--radius, 12px);
  padding: 20px;
  text-decoration: none;
  transition: border-color .15s, box-shadow .15s, transform .15s;
}
.home-nav-card:hover {
  border-color: var(--cobalt, #1F4FD8);
  box-shadow: 0 12px 28px -18px rgba(21,20,15,.25);
  transform: translateY(-2px);
}
.home-nav-card svg { flex-shrink: 0; color: var(--cobalt, #1F4FD8); margin-top: 2px; }
.home-nav-card h3 {
  font-size: 15px; font-weight: 600; color: var(--text, #1A1810); margin-bottom: 4px;
}
.home-nav-card p { font-size: 12.5px; color: var(--text-dim, #6B6858); }

@media (max-width: 560px) {
  .home-hero { padding: 32px 24px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,QAAQ,eAAe,EAAE;;AAEzB,eAAe;AACf;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,2CAA2C;EAC3C,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB,EAAE,QAAQ;EAC5B;;sEAEoE;EACpE,0BAA0B;EAC1B,iFAAiF;AACnF;AACA,qBAAqB,kBAAkB,EAAE,UAAU,EAAE,gBAAgB,EAAE;AACvE;EACE,iCAAiC;EACjC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA,wBAAwB,cAAc,EAAE;;AAExC;EACE,kBAAkB,EAAE,UAAU;EAC9B,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;AAC5C;AACA,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC9D;EACE,eAAe,EAAE,cAAc,EAAE,yBAAyB,EAAE,qBAAqB;AACnF;AACA;EACE,wCAAwC,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc;AAC7F;AACA,qBAAqB,cAAc,EAAE;;AAErC,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,SAAS;EACjD,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;EAClC,aAAa;EACb,qBAAqB;EACrB,8DAA8D;AAChE;AACA;EACE,oCAAoC;EACpC,gDAAgD;EAChD,2BAA2B;AAC7B;AACA,qBAAqB,cAAc,EAAE,6BAA6B,EAAE,eAAe,EAAE;AACrF;EACE,eAAe,EAAE,gBAAgB,EAAE,2BAA2B,EAAE,kBAAkB;AACpF;AACA,mBAAmB,iBAAiB,EAAE,+BAA+B,EAAE;;AAEvE;EACE,aAAa,kBAAkB,EAAE;AACnC","sourcesContent":[".home { max-width: 100%; }\n\n/* ── HERO ── */\n.home-hero {\n  position: relative;\n  background: var(--ink, #15140F);\n  border: 1px solid var(--line-dark, #3A3728);\n  border-radius: var(--radius, 12px);\n  padding: 44px 36px;\n  margin-bottom: 28px;\n  overflow: hidden;\n}\n.home-hero-grid {\n  position: absolute; inset: 0;\n  background-image:\n    linear-gradient(rgba(240,236,224,.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(240,236,224,.05) 1px, transparent 1px);\n  background-size: 38px 38px;\n  mask-image: radial-gradient(ellipse 80% 90% at 0% 0%, #000 30%, transparent 100%);\n}\n.home-hero-content { position: relative; z-index: 1; max-width: 640px; }\n.home-hero-title {\n  font-family: 'Oswald', sans-serif;\n  text-transform: uppercase;\n  font-size: 28px;\n  font-weight: 600;\n  letter-spacing: .02em;\n  color: #F0ECE0;\n  margin-bottom: 10px;\n}\n.home-hero-sub {\n  color: #A9A794;\n  font-size: 14.5px;\n  margin-bottom: 18px;\n  max-width: 480px;\n}\n.home-hero-link {\n  display: inline-block;\n  color: #8FADF7;\n  font-size: 13.5px;\n  font-weight: 600;\n  text-decoration: none;\n}\n.home-hero-link:hover { color: #F0ECE0; }\n\n.home-hero-stats {\n  position: relative; z-index: 1;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(240,236,224,.1);\n}\n.home-stat { display: flex; flex-direction: column; gap: 4px; }\n.home-stat span {\n  font-size: 11px; color: #8F8B78; text-transform: uppercase; letter-spacing: .04em;\n}\n.home-stat b {\n  font-family: 'JetBrains Mono', monospace; font-size: 22px; font-weight: 600; color: #F0ECE0;\n}\n.home-stat b.amber { color: #E0A354; }\n\n/* ── NAV GRID ── */\n.home-nav-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px;\n}\n.home-nav-card {\n  display: flex; align-items: flex-start; gap: 14px;\n  background: #fff;\n  border: 1px solid var(--line, #DEDACB);\n  border-radius: var(--radius, 12px);\n  padding: 20px;\n  text-decoration: none;\n  transition: border-color .15s, box-shadow .15s, transform .15s;\n}\n.home-nav-card:hover {\n  border-color: var(--cobalt, #1F4FD8);\n  box-shadow: 0 12px 28px -18px rgba(21,20,15,.25);\n  transform: translateY(-2px);\n}\n.home-nav-card svg { flex-shrink: 0; color: var(--cobalt, #1F4FD8); margin-top: 2px; }\n.home-nav-card h3 {\n  font-size: 15px; font-weight: 600; color: var(--text, #1A1810); margin-bottom: 4px;\n}\n.home-nav-card p { font-size: 12.5px; color: var(--text-dim, #6B6858); }\n\n@media (max-width: 560px) {\n  .home-hero { padding: 32px 24px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
